import React, { useEffect, useState } from "react";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import { useAuth } from "../../contexts/AuthContext";
import { useAlerts } from "../../contexts/AlertsContext";
import AlertMessageType from "../common/alert_message/AlertMessageType";
import { IApiClientError } from "../../shared/ApiClient";
import { useApiClient } from "../../contexts/ApiClientContext";
import Country from "../../model/Country";
import { User } from "../../model/User";
import { useNavigate, useParams } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import APIEndPoints from "../../utils/APIEndPoints";
import APIError from "../../utils/APIError";
import FormDropDown from "../common/FormDropDown";
import FormInputText from "../common/FormInputText";
import FormContainer from "../common/FormContainer";
import UserRoles from "../../model/enums/UserRole";
import FormDropDownYear from "../common/FormDropDownYear";
import AppSubSections from "../../utils/AppSubSections";
import FormInputCheckbox from "../common/FormInputCheckbox";

interface IUserFormErrors {
  username: string;
  password: string;
  email: string;
  surmane: string;
  name: string;
  country: string;
  affiliation: string;
  profession: string;
  activity_start: string;
}

const defaultFormErrors: IUserFormErrors = {
  username: "",
  password: "",
  email: "",
  surmane: "",
  name: "",
  country: "",
  affiliation: "",
  profession: "",
  activity_start: "",
};

export default function UserEdit() {
  const { id } = useParams();

  const [errorMessage, setErrorMessage] = React.useState("");
  const apiClient = useApiClient();
  const navigate = useNavigate();
  const alertsManager = useAlerts();
  const authManager = useAuth();

  const [countries, setCountries] = useState<Country[]>([]);

  const [formData, setFormData] = useState<User>({} as User);

  const [re_password, setRePassword] = useState<string>("");

  // set state for form errors
  const [formErrors, setFormErrors] =
    useState<IUserFormErrors>(defaultFormErrors);

  const country_options = countries.map((c) => ({
    label: c.name,
    value: c.geonameid,
  }));

  // Load the list of existing countries
  useEffect(() => {
    const loadData = async () => {
      if (id) {
        const user = await apiClient?.get<User>({
          url: APIEndPoints.USERS.ONE(parseInt(id)),
        });

        setFormData(user);
      }
      // const data = await apiClient?.get<User>({url: APIEndPoints.USERS.ONE(),requiresToken: false,})
      // .then((data: any) => {
      //     setCountries(data);
      // })
      // .catch((error: IApiClientError) => {
      //     // check if the error is one of the defaults
      //     if (!error.processed) {
      //       setErrorMessage("Could not load countries");
      //     }
      //   })
    };

    const loadCountries = async () => {
      // const cntries = await apiClient?.get<Country>({url: APIEndPoints.COUNTRIES.ALL,requiresToken: false,})
      // .then((data: any) => {
      //     setCountries(data);
      // })
      // .catch((error: IApiClientError) => {
      //     // check if the error is one of the defaults
      //     if (!error.processed) {
      //       setErrorMessage("Could not load countries");
      //     }
      //   })

      // Create an array of mock countries, with 2 simple examples
      const mockCountries = [
        { id: "1", name: "USA" },
        { id: "2", name: "Romania" },
      ];
      setCountries(mockCountries as any);
      // populate the dropdown with these mock countries

      // const cntries = [{"id": "1", "name": "USA"}, {"id": "1", "name": "RO"}]
      // setCountries(cntries)
    };

    // set the countri options variable for the drop down
    loadCountries();

    loadData();
  }, [apiClient]);

  const formInputChange = (inputID: string, newValue: string | boolean) => {
    // Special handling for re-type password field, which is a componentnt member used to validate the passowrd. we only update the value of the component member
    if (inputID === "id_re_password") {
      setRePassword(newValue as string);

      if (newValue != formData.password) {
        // Show message underneath the re-type password field that the password does not match
        setFormErrors((prevData) => ({
          ...prevData,
          password: "Passwords do not match",
        }));
      } else {
        console.log("Password match!");
        setFormErrors((prevData) => ({
          ...prevData,
          password: "",
        }));
      }
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [inputID]: newValue,
    }));
  };

  function handleSubmit(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    setFormErrors(defaultFormErrors); // Reset errors

    if (id) {
      var body = formData;
      body.id = parseInt(id);

      apiClient
        ?.put({
          url: APIEndPoints.USERS.ONE(parseInt(id)),
          body: body,
        })
        .then((response) => {
          alertsManager.showAlertMessage({
            type: AlertMessageType.SUCCESS,
            message: "User updated successfully",
          });
          navigate(
            SETTINGS.get_path({
              section: AppSections.USERS,
              id: parseInt(id),
              subsection: AppSubSections.VIEW,
            }),
          );
        })
        .catch((error: IApiClientError) => {
          if (!error.processed) {
            processAPIErrors(error);
          }
        });
    }

  }

  const processAPIErrors = (serverError: IApiClientError) => {
    try {
      // convert the error to ChemiNovaAPI custom errors
      const apiErrors = serverError.details.response.data as APIError[];
      const formErrorsCopy: any = defaultFormErrors;
      console.log(serverError);
      console.log(apiErrors);
      apiErrors.forEach((apiError) => {
        formErrorsCopy[apiError.loc[0]] = apiError.msg;
      });
      setFormErrors(formErrorsCopy);
      setErrorMessage(
        "Some of the data input is invalid. Please check and try again.",
      );
    } catch (exception) {
      console.log(exception);
      setErrorMessage("Something went wrong. Please try again later!");
    }
  };
  return (
    <div>
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-2xl xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <FormContainer
              title={"Edit User"}
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <FormInputText
                label="Username"
                id="username"
                value={formData.username}
                disabled={true}
                onChange={formInputChange}
              />

              <FormInputText
                label="Email"
                id="email"
                value={formData.email}
                // required={true}
                disabled={true}
                onChange={formInputChange}
                error={formErrors.email}
              />

              <FormInputText
                label="Name"
                id="name"
                value={formData.name}
                required={true}
                onChange={formInputChange}
                error={formErrors.name}
              />

              <FormInputText
                label="Surname"
                id="surname"
                value={formData.surname}
                required={true}
                onChange={formInputChange}
                error={formErrors.surmane}
              />

              {/* <FormDropDown
                        label="Contry"
                        id="id_country"
                        value={formData.id_country}
                        required={true}
                        options={country_options}
                        onChange={formInputChange}
                        error={formErrors.country}
                    /> */}

              <FormInputText
                label="Affiliation"
                id="affiliation"
                value={formData.affiliation}
                // required={true}
                onChange={formInputChange}
                error={formErrors.affiliation}
              />

              <FormInputText
                label="Profession"
                id="profession"
                value={formData.profession}
                // required={true}
                onChange={formInputChange}
                error={formErrors.profession}
              />

              <FormDropDownYear
                label="Activity Start Year"
                id="activity_start"
                value={
                  formData.activity_start ? String(formData.activity_start) : ""
                }
                required={true}
                onChange={formInputChange}
                error={formErrors.activity_start}
                min={1940}
                max={new Date().getFullYear()}
              />

              {/* Only allow Admin Users to change user role */}
              {/* Also prevent an admin from changing his own role */}
              {authManager.isAdmin() &&
                authManager.getUserID() != formData.id && (
                  <FormDropDown
                    label="Role"
                    id="role"
                    value={formData.role}
                    required={true}
                    options={Object.values(UserRoles).map((role) => ({
                      label: role,
                      value: role,
                    }))}
                    onChange={formInputChange}
                    error={formErrors.profession}
                  />
                )}

              { !!(authManager.isAdmin() || authManager.isBoardMember()) && authManager.getUserID() != formData.id &&
                (<div className="w-full text-left">
                  <FormInputCheckbox
                    label=""
                    details="Board Member"
                    id="board_member"
                    checked={Boolean(formData.board_member)}
                    required={false}
                    onChange={formInputChange}
                  />
                </div>)
              }

              <div className="form-buttons-container">
                <Button
                  label="Cancel"
                  purpose={ButtonAction.CANCEL}
                  onClick={() => {
                    navigate(
                      SETTINGS.get_path({
                        section: AppSections.USERS,
                        id: parseInt(id!),
                        subsection: AppSubSections.VIEW,
                      }),
                    );
                  }}
                  className="w-full text-white bg-red-500 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300"
                />
                <Button
                  label={"Update User info"}
                  purpose={ButtonAction.SAVE}
                  isSubmit={true}
                  // onClick={handleSubmit}
                  className="w-full"
                />
              </div>
            </FormContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
